import apiClient from "@/api/client";
import type { Z7GenerationInfo, Z7Overview } from "./z7types";

const BASE = "/power-projects/z7";

async function unwrap<T>(p: Promise<{ data: { data: T } }>): Promise<T> {
  const r = await p;
  return r.data.data;
}

export const getZ7Overview = (connectionId: string) =>
  unwrap<Z7Overview>(apiClient.get(`${BASE}/overview/`, { params: { connection: connectionId } }));

export const z7RefreshRows = (connectionId: string) =>
  unwrap<{ created: number; removed: number; total: number }>(
    apiClient.post(`${BASE}/refresh-rows/`, { connection: connectionId }));

export const z7RefreshDxf = (connectionId: string) =>
  unwrap<{ parcels: number; skipped_elements: string[] }>(
    apiClient.post(`${BASE}/refresh-dxf/`, { connection: connectionId }));

export const z7AnalyzePt = (connectionId: string, opts: { fileId?: string; upload?: File }) => {
  if (opts.upload) {
    const fd = new FormData();
    fd.append("connection", connectionId);
    fd.append("file", opts.upload);
    return unwrap<{ task_id: string }>(
      apiClient.post(`${BASE}/analyze-pt/`, fd, { headers: { "Content-Type": "multipart/form-data" } }));
  }
  return unwrap<{ task_id: string }>(
    apiClient.post(`${BASE}/analyze-pt/`, { connection: connectionId, file_id: opts.fileId }));
};

export const z7UpdateRow = (rowId: string, body: Record<string, unknown>) =>
  unwrap<unknown>(apiClient.patch(`${BASE}/${rowId}/row/`, body));

export const z7UpdateQuantities = (
  rowId: string,
  cells: { column: string; value?: string | null; clear?: boolean; note?: string }[],
) => unwrap<unknown>(apiClient.patch(`${BASE}/${rowId}/quantities/`, { cells }));

export const z7Rates = () =>
  unwrap<{ code: string; label: string; section: string; unit: string; rate: string; group: string }[]>(
    apiClient.get(`${BASE}/rates/`));

export const z7SaveRates = (rates: { code: string; rate: string }[]) =>
  unwrap<unknown>(apiClient.patch(`${BASE}/rates/`, { rates }));

export const z7Generate = (
  connectionId: string,
  body: { format: string; doc_number: string; duplicate_quantities: boolean; row_ids?: string[] },
) =>
  unwrap<{ id: string; file: { id: string; url?: string | null; original_filename?: string }; totals: Record<string, unknown>; warning: string | null }>(
    apiClient.post(`${BASE}/generate/`, { connection: connectionId, ...body }));

export const z7Generations = (connectionId: string) =>
  unwrap<Z7GenerationInfo[]>(apiClient.get(`${BASE}/generations/`, { params: { connection: connectionId } }));
